import { ApiSuccessResponse } from 'network/config/interface';
import {
  AuthSuccess,
  BusinessRegisterRequest,
  ILogin,
  IRegister,
  RequestOtp,
  ResetPassword,
  ResetPasswordResponse,
  ResponseSuccess,
  updatePassword,
  VerifyOtp
} from 'TYPES/api.body';
import {
  BUSINESS_REGISTER,
  GOOGLE_LOGIN,
  LOGIN,
  LOGOUT,
  NEW_PASSWORD,
  REGISTER,
  REQUEST_OTP,
  RESET_PASSWORD,
  VERIFY_OTP
} from '../config/endpoints';
import api from '../config/setAuthHeader';

export const login = async (formData: ILogin & { email?: string }) => {
  const email = (formData.email ?? formData.identifier).trim().toLowerCase();
  return await api.post(LOGIN, { email, password: formData.password });
};

export const logout = async () => {
  const token =
    localStorage.getItem('access_token')?.trim() || sessionStorage.getItem('access_token')?.trim();
  if (!token || token === 'undefined' || token === 'null') {
    return { data: { status: 'success', message: 'Already logged out' } };
  }
  return api.post(LOGOUT, {}, { headers: { Authorization: `Bearer ${token}` } });
};

export const register = async (formData: IRegister) => {
  const { referralCode, firstname, lastname, email, phoneNumber, password } = formData;
  return await api.post(REGISTER, {
    firstname,
    lastname,
    email,
    phoneNumber,
    password,
    referral_code: referralCode ?? null
  });
};

export const resetPassword = async (formData: ResetPassword): Promise<ResponseSuccess<ResetPasswordResponse>> => {
  return await api.post(RESET_PASSWORD, formData);
};

export const newPassword = async (formData: updatePassword) => {
  return await api.post(NEW_PASSWORD, formData);
};

export const verifyOtp = async (payload: VerifyOtp) => {
  return await api.post(VERIFY_OTP, { ...payload });
};

/** Resend signup verification OTP (`POST /customer/auth/resend-otp`). */
export const resendSignupOtp = async (payload: RequestOtp) => {
  return await api.post(REQUEST_OTP, payload);
};

/** @deprecated Use resendSignupOtp for signup verification resend. */
export const requestOtp = resendSignupOtp;
export const registerBusiness = async (input: BusinessRegisterRequest) => {
  return await api.post(BUSINESS_REGISTER, input, {
    headers: { 'Content-Type': 'application/json' }
  });
};

export const googleLoginCallback = async (accessToken: string): Promise<ApiSuccessResponse<AuthSuccess>> => {
  return await api.get(GOOGLE_LOGIN.concat(`?access_token=${accessToken}`));
};

// export const appleLoginCallback = async (idToken: string) => {
//   const response = await fetch('/auth/apple-callback', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded'
//     },
//     body: new URLSearchParams({
//       id_token: idToken
//     })
//   });

//   return response.json();
// };
